export default __webpack_public_path__ + "static/media/volkihar-slide-3.6156e25e.jpg";